import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

// Sets time at local day start
export const getDateByDayStart = (date) => {
   if (!(date instanceof Date)) {
      throw new TypeError('Argument must be a Date type');
   }
   const dateCopy = new Date(date.getTime());
   dateCopy.setHours(0, 0, 0, 0);
   return dateCopy;
};

// Sets time at local day end
export const getDateByDayEnd = (date) => {
   if (!(date instanceof Date)) {
      throw new TypeError('Argument must be a Date type');
   }
   const dateCopy = new Date(date.getTime());
   dateCopy.setHours(23, 59, 59, 999);
   return dateCopy;
};

// Returns current date (yyyy-MM-DD) at timeZone='America/Los_Angeles'
export const getTodayServerDateStr = () => {
   const formatter = new Intl.DateTimeFormat([], {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour12: false,
   });

   const dateStr = formatter.format(new Date());
   const [month, day, year] = dateStr.split('/');
   return `${ year }-${ month }-${ day }`;
};

const isValidDateStringFormat = (dateStr) => {
   return !!`${dateStr}`.match(/^\d{4}-\d{2}-\d{2}$/);
};

export const toStringDate = (date) => {
   let stringDate;

   if (isValidDateStringFormat(date)) {
      stringDate = date;
   } else if (date instanceof Date) {
      let day = date.getDate();
      if (`${ day }`.length === 1) {
         day = `0${ day }`;
      }
      const year = date.getFullYear();
      let month = +date.getMonth() + 1;

      if (`${ month }`.length === 1) {
         month = `0${ month }`;
      }
      stringDate = `${ year }-${ month }-${ day }`;
   } else {
      throw new TypeError('Argument must be a Date or String type');
   }

   return stringDate;
};

// dateStr parameter YYYY-MM-DD
export const fromStringDateToDate = (dateStr) => {
   const [year, month, day] = dateStr.split("-");
   const monthIndex = +month - 1;
   return new Date(year, monthIndex, day);
};

export const getDateAsServerDate = (date) => {
   if (!(date instanceof Date)) {
      throw new TypeError('Argument must be a Date type');
   }
   let day = date.getDate();
   if (`${ day }`.length === 1) {
      day = `0${ day }`;
   }
   const year = date.getFullYear();
   let month = +date.getMonth() + 1;

   if (`${ month }`.length === 1) {
      month = `0${ month }`;
   }

   const hour = date.getHours();
   const minute = date.getMinutes();

   return dayjs.tz(`${ year }-${ month }-${ day } ${ hour }:${ minute }`, 'America/Los_Angeles').toDate();
};

// Returns yyyy-MM-dd
export const getDateAsLocalDateStr = (date) => {
   if (!(date instanceof Date)) {
      throw new TypeError('Argument must be a Date type');
   }

   const dateCopy = new Date(date.getTime());
   const offset = dateCopy.getTimezoneOffset();
   const adjustedToUtcDate = new Date(dateCopy.getTime() - (offset * 60 * 1000));
   return Date.prototype.toISOString.call(adjustedToUtcDate).split('T')[0];
};

export const getDateServerDateStr = (date) => {
   if (!(date instanceof Date)) {
      throw new TypeError('Argument must be a Date type');
   }

   const formatter = new Intl.DateTimeFormat([], {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour12: false,
   });

   const dateStr = formatter.format(date);
   const [month, day, year] = dateStr.split('/');
   return `${ year }-${ month }-${ day }`;
};

export const getDateObjAtLocalTimeFromString = (dateString) => {
   if (!dateString.length) {
      return new Date();
   }
   return new Date(`${ dateString }T00:00`);
};
